import PropTypes from 'prop-types';

export default function LoadingSpinner({ label = 'Loading…', className = '' }) {
  return (
    <div className={`inline-flex items-center gap-2 text-secondary-text ${className}`}>
      <span className="inline-block w-4 h-4 rounded-full border-2 border-card-border border-t-transparent animate-spin" aria-hidden="true" />
      <span className="text-sm">{label}</span>
    </div>
  );
}

LoadingSpinner.propTypes = {
  label: PropTypes.string,
  className: PropTypes.string,
};